import type { TFunction } from "i18next";

/** The checks whose ID is fixed and is their kind (the server's kernel/checks.py); every other check ID is the checked item's reference. */
export const MODEL_CHECK_IDS: ReadonlySet<string> = new Set(["consistency", "unsatisfiable_classes"]);

/** A check kind in the reader's words, as the checks list, the conflicts panel and the blocked banner say it. */
export function checkKindText(kind: string, t: TFunction): string {
  return t(`reviews.checks.kinds.${kind}`, { defaultValue: kind });
}
